import { useMutation } from 'react-query';
import http from '../http';

const updateUobPointRedemption = ({
  mc_product,
  uob_point_redemption_id,
}: UpdateUobPointRedemptionPayload) =>
  http.put<UpdateUobPointRedemptionPayload>(
    `/v1/mc_products/${uob_point_redemption_id}`,
    mc_product,
  );

export const useUpdateUobPointRedemption = () =>
  useMutation(updateUobPointRedemption);

export type UpdateUobPointRedemptionPayload = {
  mc_product: FormData;
  uob_point_redemption_id: string;
};
